var Ractive = require('ractive');
var component = module;

  component.exports = {
    onrender: function (options) {
      var self = this;

      if (Global.Callbacks['menu']) {
				Global.Callbacks['menu'].fire('doListCaption', "Firma");
			}			

      self.on('doRefresh', function (e) {

      });
      self.fire('doRefresh');
    },
    data: function () {
      return {
        loading: false,
        UserRow: [],
        CacheData: {
          Users: {}
        },
        Config: {
          UserNotFoundTab: 'notfound'
        },
        InfoKeyClient: "",
        PasswordReset: {
          Step: 1,
          NewPasswordNotValid: false,
          NewPassword: ""
        },
        displayName: "enter",
        displayLast: "enter",
        User: {
          InfoKey: "",
          Title: "",
          Email: "",
          UserName: "",
          UserPass: "",
          RememberMe: true
        },
        login: {
          InfoKey: "",
          UserName: "",
          UserPass: "",
          RememberMe: true
        },
				LinkHelp: "",
				LinkManual: "",        
        d: Client.createDisplay(),
        Lng: SiteLng,
        isVisible: function(iInfoKey, iUser){
          if(iInfoKey){
            return (iUser&&iUser.UserName&&iUser.UserName!="visitor"&&iUser.InfoKey==iInfoKey);
          }else{
            return (iUser&&iUser.UserName&&iUser.UserName!="visitor");
          }
        },
        getGroups: function(iValue){
          const myJson = Format.formatXml2Json(iValue);
          //console.log('xml', myJson[0]);
          return (myJson&&0<myJson.length)? myJson[0]:[];
        },
        hasGroupAdmin: function(iValue){
          if(iValue){
            const myJson = Format.formatXml2Json(iValue);

            if(myJson&&0<myJson.length&&myJson[0]){
              for(i=0; i<myJson[0].length; i++){
                if(myJson[0][i][0]=="Admins"){
                  return true;
                }
              }
            }            
          }

          return false;
        }
      }
    }
  }

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"class",f:"container-fluid",t:13}],f:[{p:[2,3,33],t:7,e:"div",m:[{n:"class",f:"page-content",t:13}],f:[{p:[3,5,65],t:7,e:"div",m:[{n:"class",f:"card custom-card",t:13}],f:[{p:[4,7,103],t:7,e:"div",m:[{n:"class",f:"card-header",t:13}],f:[{p:[5,9,138],t:7,e:"div",m:[{n:"class",f:"card-title text-uppercase",t:13}],f:[" ",{t:2,r:"Owner.OwnerName",p:[5,54,183]}]}]}," ",{p:[7,7,230],t:7,e:"div",m:[{n:"class",f:"card-body",t:13}],f:[{p:[8,9,263],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{p:[9,11,292],t:7,e:"div",m:[{n:"class",f:"col-sm-8 col-xs-12",t:13}],f:[{p:[10,13,338],t:7,e:"Element-Input",m:[{n:"title",f:"Naziv Firme",t:13},{n:"value",f:[{t:2,r:"Owner.OwnerName",p:[10,54,379]}],t:13},{n:"mandatory",f:"true",t:13}]}]}," ",{p:[12,11,462],t:7,e:"div",m:[{n:"class",f:"col-sm-2 col-xs-6",t:13}],f:[{p:[13,13,507],t:7,e:"Element-Input",m:[{n:"title",f:"PIB",t:13},{n:"value",f:[{t:2,r:"Owner.OwnerPIB",p:[13,46,540]}],t:13},{n:"mandatory",f:"true",t:13}]}]}," ",{p:[15,11,622],t:7,e:"div",m:[{n:"class",f:"col-sm-2 col-xs-6",t:13}],f:[{p:[16,13,667],t:7,e:"Element-Input",m:[{n:"title",f:"MB",t:13},{n:"value",f:[{t:2,r:"Owner.OwnerMB",p:[16,45,699]}],t:13},{n:"mandatory",f:"true",t:13}]}]}]}," ",{p:[19,9,794],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{p:[20,11,823],t:7,e:"div",m:[{n:"class",f:"col-sm-6 col-md-6 col-lg-6",t:13}],f:[{p:[21,13,877],t:7,e:"Element-Input",m:[{n:"title",f:"Vlasnik",t:13},{n:"value",f:[{t:2,r:"Owner.ContactName",p:[21,50,914]}],t:13},{n:"mandatory",f:"true",t:13}]}]}," ",{p:[23,11,999],t:7,e:"div",m:[{n:"class",f:"col-sm-6 col-md-6 col-lg-6",t:13}],f:[{p:[24,13,1053],t:7,e:"Element-Input",m:[{n:"title",f:"Office Email",t:13},{n:"value",f:[{t:2,r:"Owner.ContactEmail",p:[24,55,1095]}],t:13},{n:"mandatory",f:"true",t:13}]}]}]}," ",{p:[27,9,1195],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{p:[28,11,1224],t:7,e:"div",m:[{n:"class",f:"col-sm-6 col-md-6 col-lg-6",t:13}],f:[{p:[29,13,1278],t:7,e:"Element-Input",m:[{n:"title",f:"Ulica",t:13},{n:"value",f:[{t:2,r:"Owner.AddressStreetName",p:[29,48,1313]}],t:13}]}]}," ",{p:[31,11,1387],t:7,e:"div",m:[{n:"class",f:"col-sm-6 col-md-6 col-lg-4",t:13}],f:[{p:[32,13,1441],t:7,e:"Element-Input",m:[{n:"title",f:"Grad",t:13},{n:"value",f:[{t:2,r:"Owner.AddressCityName",p:[32,47,1475]}],t:13}]}]}," ",{p:[34,11,1547],t:7,e:"div",m:[{n:"class",f:"col-sm-6 col-md-6 col-lg-2",t:13}],f:[{p:[35,13,1601],t:7,e:"Element-Input",m:[{n:"title",f:"PTT",t:13},{n:"value",f:[{t:2,r:"Owner.AddressPostalZone",p:[35,46,1634]}],t:13}]}]}]}]}," ",{p:[39,7,1734],t:7,e:"div",m:[{n:"class",f:"card-footer",t:13}],f:[{p:[40,9,1769],t:7,e:"button",m:[{n:"class",f:"btn btn-lg btn-success",t:13}],f:["Snimi"]}," "]}]}]}]}]};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/Owner.html
// module id = 30
// module chunks = 0